import {
  ADD_TO_BREADCRUMB,
  COLLAPSE_SIDEBAR,
  CREATE_BREADCRUMB,
  LOADING,
  LOGIN,
  LOGOUT,
  REMOVE_FROM_BREADCRUMB,
  UPDATE_FAVOURITE_LIST,
} from "./actions";

enum BreadcrumbTypes {
  TEXT = "text",
  LINK = "link",
}

const reducer: any = (state = initialState(), action: any) => {
  if (action.type === LOADING) {
    return {
      ...state,
      loading: action.payload,
    };
  }
  if (action.type === LOGIN) {
    localStorage.setItem("star_user", JSON.stringify(action.payload?.user));
    return {
      ...state,
      user: action.payload?.user,
    };
  }
  if (action.type === LOGOUT) {
    localStorage.removeItem("star_user");
    return {
      ...state,
      user: null,
    };
  }
  if (action.type === UPDATE_FAVOURITE_LIST) {
    localStorage.setItem(
      "star_user",
      JSON.stringify({
        ...state,
        user: {
          ...state.user,
          favoriteList: action.payload,
        },
      })
    );

    return {
      ...state,
      user: {
        ...state.user,
        favoriteList: action.payload,
      },
    };
  }
  if (action.type === CREATE_BREADCRUMB) {
    localStorage.removeItem("breadcrumb");
    localStorage.setItem(
      "breadcrumb",
      JSON.stringify(action.payload.breadcrumb)
    );
    return {
      ...state,
      breadcrumb: action.payload.breadcrumb,
    };
  }
  if (action.type === COLLAPSE_SIDEBAR) {
    return {
      ...state,
      collapseSidebar: !state.collapseSidebar,
    };
  }
  if (action.type === ADD_TO_BREADCRUMB) {
    const currentBreadcrumb =
      JSON.parse(localStorage.getItem("breadcrumb") as string) || [];

    const alreadyExists = currentBreadcrumb?.some((item: any) =>
      action?.payload?.breadcrumb
        ?.map((ele: any) => ele.text)
        .includes(item.text)
    );

    if (alreadyExists) {
      return state;
    }
    if (action?.payload?.breadcrumb[0]?.type === BreadcrumbTypes.TEXT) {
      currentBreadcrumb?.push({
        text: action?.payload?.breadcrumb[0]?.text,
        type: BreadcrumbTypes.TEXT,
      });
      localStorage.setItem("breadcrumb", JSON.stringify(currentBreadcrumb));
    } else {
      currentBreadcrumb?.push({
        text: action?.payload?.breadcrumb[0]?.text,
        link: action?.payload?.breadcrumb[0]?.link,
        type: BreadcrumbTypes.LINK,
      });
      localStorage.setItem("breadcrumb", JSON.stringify(currentBreadcrumb));
    }
    return {
      ...state,
      breadcrumb: JSON.parse(localStorage.getItem("breadcrumb") as string),
    };
  }
  if (action.type === REMOVE_FROM_BREADCRUMB) {
    const currentBreadcrumb = JSON.parse(
      localStorage.getItem("breadcrumb") as string
    );

    const element = currentBreadcrumb?.some((item: any) =>
      action?.payload?.breadcrumb
        ?.map((ele: any) => ele.text)
        .includes(item.text)
    );
    if (element) {
      const updatedBreadcrumb = currentBreadcrumb?.filter(
        (item: any) =>
          !action?.payload?.breadcrumb
            ?.map((ele: any) => ele.text)
            .includes(item.text)
      );
      localStorage.setItem("breadcrumb", JSON.stringify(updatedBreadcrumb));
    } else {
      return state;
    }

    return {
      ...state,
      breadcrumb: JSON.parse(localStorage.getItem("breadcrumb") as string),
    };
  }
  return state;
};

const initialState = () => {
  return {
    loading: false,
    user: JSON.parse(
      localStorage.getItem("star_user")
        ? localStorage.getItem("star_user") || "{}"
        : "{}"
    ),
    breadcrumb: JSON.parse(localStorage.getItem("breadcrumb") as string),
    collapseSidebar: false,
  };
};

export default reducer;
